import React from 'react';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const COLORS = {
  red: 'indianred',
  darkRed: 'darkred',
  green: 'green',
  yellow: 'orange',
};


const FasiChart = ({ fasi , Tc, tempogiallo, tempotuttorosso }) => {

  const labels = fasi.map((fase) => fase.nome);
  const datasets = [];



  fasi.forEach((fase, i) => {
    const isPedonale = fase.tipo == "pedonale" 
    const verdeEfficace = isPedonale ? fase.verde_min_ped : fase.verde_efficace || 0;

    const segments = [];
    segments.push({ value: fase.inizio, color: "indianred" })
    segments.push({ value: verdeEfficace, color: "green" })
    segments.push({ value: tempogiallo, color: "orange" })
    segments.push({ value: tempotuttorosso, color: "darkred" })
    segments.push({ value: Tc - fase.fine, color: "indianred" })
    


    // Map each segment to its dataset
    segments.forEach((seg, j) => {
      if (!datasets[j]) {
        datasets[j] = {
          label: `Segment ${j + 1}`,
          data: Array(fasi.length).fill(0),
          backgroundColor: seg.color,
          stack: 'combined',
          barThickness: 15,
        };
      }
      datasets[j].data[i] = seg.value;
    });
  });


  const data = {
    labels,
    datasets,
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `Duration: ${ctx.raw}s`,
        },
      },
    },
    scales: {
      x: {
        max: Tc,
        title: {
          display: true,
          text: 'Tempo (s)',
        },
      },
      y: {
        ticks: {
          font: {
            weight: 'bold',
          },
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default FasiChart;